module.exports = __webpack_public_path__ + "img/newsImg11-25.4845659b.png";